import { Check } from 'lucide-react';
import clsx from 'clsx';

interface SlotYouMarkProps {
  hasHeat?: boolean;
  size?: number;
}

export function SlotYouMark({ hasHeat = false, size = 14 }: SlotYouMarkProps) {
  return (
    <span className="pointer-events-none absolute inset-0 z-[2] flex items-center justify-center">
      <Check
        size={size}
        strokeWidth={2.75}
        className={clsx(
          hasHeat ? 'text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.35)]' : 'text-room-accent'
        )}
        aria-hidden
      />
    </span>
  );
}
